import { render, staticRenderFns } from "./DocsNav.vue?vue&type=template&id=554f34ba&"
import script from "./DocsNav.vue?vue&type=script&lang=js&"
export * from "./DocsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports